import ConfettiComponent from "@/components/confetti";
import { SupportMessage } from "@/components/layout-loading/support-message";
import { Button } from "@/components/ui/button";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { useEffect, useState } from "react";

type SetupFinishStepProps = {
  apiEndpoint: string;
  translationPrefix: string;
  successButtonKey?: string;
};

export const SetupFinishStep = ({
  apiEndpoint,
  translationPrefix,
  successButtonKey = "home",
}: SetupFinishStepProps) => {
  const api = useApi();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const finish = async () => {
      try {
        setIsLoading(true);
        await api.post(apiEndpoint);
        setIsSuccess(true);
      } catch {
        setIsSuccess(false);
      } finally {
        setIsLoading(false);
      }
    };
    finish();
  }, []);

  if (isLoading) {
    return <div>{t(`${translationPrefix}.loading`)}</div>;
  }

  if (!isSuccess) {
    return (
      <div className="space-y-5 text-center">
        <h1 className="text-2xl font-bold text-primary">
          {t(`${translationPrefix}.error.title`)}
        </h1>
        <p>{t(`${translationPrefix}.error.description`)}</p>
        <SupportMessage />
        <Button onClick={() => window.location.reload()}>
          {t(`${translationPrefix}.buttons.retry`)}
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-5 text-center">
      <h1 className="text-2xl font-bold text-primary">
        {t(`${translationPrefix}.success.title`)}
      </h1>
      <p className="text-md">{t(`${translationPrefix}.success.description`)}</p>
      <Button
        onClick={() => {
          window.location.href = "/";
        }}
      >
        {t(`${translationPrefix}.buttons.${successButtonKey}`)}
      </Button>
      <ConfettiComponent />
    </div>
  );
};
